import Vue from "vue";
import Router from "vue-router";
import Call from "./../components/call";
import Chat from "./../components/chat";
import Form from "./../components/form";
import Survey from "./../components/survey";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      component: Form,
    },
    {
      path: "/call",
      name: "call",
      component: Call,
    },
    {
      path: "/chat",
      name: "chat",
      component: Chat,
    },
    {
      path: "/form",
      name: "form",
      component: Form,
    },
    {
      path: "/survey",
      name: "survey",
      component: Survey,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.hasQueryParamPage)) {
    let updatedNext = null;

    if (!Object.prototype.hasOwnProperty.call(to.query, "page")) {
      updatedNext = {
        ...to,
        query: {
          // This line is used to retain other query if there is any
          ...to.query,
          page: 1,
        },
      };
    }

    if (updatedNext) {
      next(updatedNext);
      return;
    }
  }

  next();
});

export default router;
